import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'
  const {
    palette: {
      blue_300: { main: blue300 } = {},
      blue_50: { main: blue50 } = {},
      gray_300: { main: gray300 } = {},
      gray_400: { main: gray400 } = {},
      gray_stroke: { main: grayStroke } = {},
      white_100: { main: white100 } = {},
      red_100: { main: red100 } = {},
      dark_50: { main: dark50 } = {},
      dark_400: { main: dark400 } = {},
      dark_stroke: { main: darkStroke } = {}
    } = {}
  } = theme
  return {
    table: {
      '& .MuiTableCell-sizeSmall': {
        padding: '0px 16px !important'
      }
    },
    tableCellTitle: {
      fontWeight: '600',
      fontSize: '1rem',
      color: blue300,
      borderBottom: `1px solid ${isDark ? darkStroke : grayStroke}`
    },
    tableCellMessage: {
      color: isDark ? dark50 : gray400,
      borderBottom: `1px solid ${isDark ? darkStroke : grayStroke}`
    },
    tableRowEven: {
      backgroundColor: isDark ? dark400 : blue50
    },
    tableRowOdd: {
      backgroundColor: isDark ? dark400 : white100
    },
    buttonActionEdit: {
      padding: '4px',
      borderRadius: 8,
      color: isDark ? dark50 : gray300,
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: blue300,
        color: white100
      }
    },
    buttonActionDelete: {
      padding: '4px',
      borderRadius: 8,
      color: red100,
      '&:hover': {
        backgroundColor: red100,
        color: white100
      }
    },
    tableContainer: {
      width: '100%',
      overflowX: 'auto'
    }
  }
})
